<template>
  <div class="panel-errores p-3">
    <!-- <h3 id="cabeceraDashboard" class="text-dark mb-3 h3 pl-2">Panel de Errores</h3> -->

    <p class="mb-4">
        <span class="fas fa-exclamation-triangle fa-lg icon-hover-grow pt-2"></span>
        <span id="cabeceraDashboard" class="text-dark mb-0 h3 pl-2">Panel de Errores</span>
      </p>

    <b-table
        :items="errores"
        :fields="fields"
        striped
        hover
        responsive
        show-empty
        empty-text="No hay errores registrados"
        class="minimal-table shadow-sm rounded"
    >
      <template #cell(created_at)="data">
        <span class="">{{ data.value }}</span>
      </template>

      <template #cell(service)="data">
        <b-badge :variant="getBadgeVariant(data.value)" class="text-uppercase p-2">
          {{ getServiceLabel(data.value) }}
        </b-badge>
      </template>

      <template #cell(actions)="data">
        <b-button size="sm" class="btn-orange rounded-pill px-3" @click="verDetalle(data.item)">
          Ver Detalle
        </b-button>
      </template>
    </b-table>

    <b-modal
        v-model="modalDetalle"
        title="Detalle del Error"
        size="lg"
        hide-footer
        header-close-content="&times;"
        header-class="border-bottom-0 pb-0"
    >
      <div v-if="errorSeleccionado" class="px-2">

        <div class="error-meta-summary mb-4 p-3 bg-light rounded border shadow-sm">
  <div class="d-flex flex-wrap gap-3 mb-3">
    <div class="meta-item">
      <small class="text-muted d-block uppercase-label">FECHA DE DETECCION DEL ERROR</small>
      <span class="fw-bold">{{ errorSeleccionado.created_at }}</span>
    </div>

    <div class="meta-item border-start ps-3">
      <small class="text-muted d-block uppercase-label">Origen</small>
      <b-badge :variant="getBadgeVariant(errorSeleccionado.service)">
        {{ getServiceLabel(errorSeleccionado.service) }}
      </b-badge>
    </div>

    <div class="meta-item border-start ps-3">
      <small class="text-muted d-block uppercase-label">Categoría (Razón)</small>
      <span class="text-dark fw-bold">{{ errorSeleccionado.reason }}</span>
    </div>
  </div>

  <div v-if="errorSeleccionado.error_message" class="error-message-box mt-2 p-2 rounded">
    <small class="text-muted d-block uppercase-label mb-1">Descripción del Error</small>
    <p class="mb-0 text-danger-emphasis fw-medium italic">
      <i class="bi bi-info-circle me-1"></i> "{{ errorSeleccionado.error_message }}"
    </p>
  </div>
</div>

        <div class="content-card mb-4 rounded shadow-sm overflow-hidden">

          <div class="card-header-custom p-3 border-bottom">
            <h5 class="text-orange mb-0 fw-bold">
              {{ errorSeleccionado.history_available ? 'Mensaje Original' : 'Datos de Entrada' }}
            </h5>
          </div>

          <div class="card-body-custom p-4 bg-history">
            <div>
              <div class="message-text">
                {{ errorSeleccionado.message_data?.text }}
              </div>
              
              <div v-if="!errorSeleccionado.history_available">
                <pre class="json-payload">{{ prettyJson(errorSeleccionado.payload) }}</pre>
              </div>

              <div class="footer-metadata mt-4 pt-2 border-top">
                {{ errorSeleccionado.message_data?.chat && `Grupo: ${errorSeleccionado.message_data?.chat} |` }} Fecha de recepción
                {{ errorSeleccionado.message_data?.created_at || errorSeleccionado.created_at }}
              </div>
            </div>

          </div>
        </div>

        <div v-if="hasErrorDetails" class="errors-section">
          <h5 class="text-danger fw-bold m-3">Detalles de Validación</h5>

          <div show variant="danger" class="border-0 shadow-sm p-3 m-0">
            <div v-if="normalizedErrorDetails.fields && Array.isArray(normalizedErrorDetails.fields)">
              <p class="fw-bold small m-0 mb-1">El mensaje no contiene información de los campos:</p>
              <ul class="mb-0 custom-list">
                <li v-for="(field, index) in normalizedErrorDetails.fields" :key="'field-'+index">
                  {{ field }}
                </li>
              </ul>
            </div>

            <div v-else-if="isObject(normalizedErrorDetails)">
              <p class="fw-bold small">Detalles técnicos del error:</p>
              <ul class="mb-0 custom-list">
                <li v-for="(value, key) in normalizedErrorDetails" :key="'detail-'+key">
                  <strong>{{ key }}:</strong> {{ value }}
                </li>
              </ul>
            </div>

            <div v-else>
              {{ normalizedErrorDetails }}
            </div>
          </div>
        </div>

        <div class="text-end pb-3 mt-3">
          <b-button variant="secondary" class="px-4 shadow-sm" @click="modalDetalle = false">Cerrar</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import auth from "../auth";

export default {
  name: 'PanelErrores',
  data() {
    return {
      errores: [],
      fields: [
        {key: 'created_at', label: 'Fecha', sortable: true},
        {key: 'service', label: 'Origen', sortable: true},
        {key: 'reason', label: 'Razón', sortable: true},
        {key: 'actions', label: 'Acciones', class: 'text-center'}
      ],
      modalDetalle: false,
      errorSeleccionado: null
    };
  },
  async created() {
    this.$store.state.botonEditar = false;
  },
  computed: {
    normalizedErrorDetails() {
      const details = this.errorSeleccionado?.error_details;
      if (typeof details === 'string') {
        try {
          return JSON.parse(details);
        } catch {
          return details;
        }
      }
      return details || null;
    },
    hasErrorDetails() {
      const details = this.normalizedErrorDetails;
      if (!details) return false;
      if (typeof details === 'string') return details.length > 0;
      if (Array.isArray(details.fields)) return details.fields.length > 0;
      return Object.keys(details).length > 0;
    }
  },
  mounted() {
    this.cargarErrores();
  },
  methods: {
    prettyJson(val) {
      if (typeof val !== 'object') return val;
      return JSON.stringify(val, null, 2);
    },
    async cargarErrores() {
      try {
        const response = await fetch('api/etlred/errors', {
          headers: auth.getAuthHeader()
        });
        const data =  await response.json();
        this.errores = data
      } catch (error) {
        console.error('Error cargando los logs de errores:', error);
      }
    },
    getServiceLabel(service) {
      const labels = {
        'telegram': 'Telegram',
        'endpoint': 'API',
        'process message': 'Procesamiento'
      };
      return labels[service] || service; // Si no existe, muestra el original
    },
    getBadgeVariant(service) {
      const variants = {
        'telegram': 'primary',
        'endpoint': 'info'
      };
      return variants[service] || 'secondary';
    },
    verDetalle(item) {
      this.errorSeleccionado = item;
      this.modalDetalle = true;
    },
    isObject(val) {
      return val !== null && typeof val === 'object' && !Array.isArray(val);
    }
  }
};
</script>

<style scoped>
/* Colores base */
.text-orange {
  color: #ff8800 !important;
}

/* Botones */
.btn-orange {
  background-color: #ff8800 !important;
  border-color: #ff8800 !important;
  color: white !important;
  font-weight: 500;
}

.btn-orange:hover {
  background-color: #e67a00 !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Tabla */
.minimal-table :deep(thead th) {
  background-color: #f8f9fa;
  color: #666;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Estilo de la "Card" dentro del Modal similar a la imagen */
.content-card {
  border: 1px solid #ffd8a8;
}

.card-header-custom {
  background-color: #fffaf4;
}

.bg-history {
  background-color: #fffdfa; /* Fondo muy claro casi blanco/crema */
}

/* Texto del mensaje */
.message-text {
  white-space: pre-wrap;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 0.95rem;
  color: #444;
  line-height: 1.6;
}

.footer-metadata {
  font-size: 0.8rem;
  opacity: 0.7;
}

/* Visor de Payload cuando no hay historia */
.json-payload {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 5px;
  font-size: 0.85rem;
  color: #333;
  max-height: 400px;
  overflow: auto;
  border: 1px solid #eee;
}

/* Listas y Alertas */
.custom-list {
  list-style-type: none;
  padding-left: 0;
}

.custom-list li::before {
  content: "•";
  color: #dc3545;
  font-weight: bold;
  display: inline-block;
  width: 1em;
}

/* Ajustes generales del modal */
:deep(.modal-content) {
  border-radius: 12px;
  border: none;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

:deep(.modal-header .btn-close) {
  font-size: 1.2rem;
}

.uppercase-label {
  text-transform: uppercase;
  font-size: 0.7rem;
  letter-spacing: 0.5px;
  font-weight: 700;
}

.error-meta-summary {
  background-color: #fcfcfc !important;
}

.meta-item {
  min-width: 120px;
}

/* Mejora la separación visual del modal */
.errors-section {
  border-top: 1px dashed #dee2e6;
  padding-top: 10px;
}

/* Ajuste para que el badge dentro del modal no sea tan grande */
.meta-item .badge {
  font-size: 0.8rem;
  padding: 5px 10px;
}

.error-message-box {
  background-color: #fff5f5; /* Un rojo/rosa muy suave */
  border-left: 4px solid #dc3545; /* Barra lateral roja de peligro */
}

.text-danger-emphasis {
  color: #a52834;
  font-style: italic;
  font-size: 0.95rem;
}

.italic {
  font-style: italic;
}
</style>